import {gql} from 'graphql-tag';

export const CREATE_ANALYTICS = gql`
  mutation createAnalyticsRecord($analyticsCreateInput: AnalyticsCreateInput!) {
    createAnalyticsRecord(analyticsCreateInput: $analyticsCreateInput) {
      id
    }
  }
`;
